import toSnakeCase from "to-snake-case"; // Imported as dependency of "snakecase-keys"...
import camelcase from "camelcase";
import { camelCaseToUnderscore } from "@transformers/string";

export const sortObjToStr = (sort: { id: string, direction: string }) => {
  return `${camelCaseToUnderscore(sort.id)},${sort.direction}`;
};

export const transformSort = (sort: *) => {
  if (!sort) {
    return sort;
  }

  const valuesToSort = Array.isArray(sort) ? sort : [sort];
  return valuesToSort.map(item => ({ property: item.id, direction: item.direction.toUpperCase() }));
};

export const toTableSort = (sort: Array<{ property: string, direction: string }>) => {
  if (!sort || !sort[0]) {
    return undefined;
  }

  return {
    id: camelcase(sort[0].property),
    direction: sort[0].direction.toLowerCase(),
  };
};

// Now sortToString supports more than one array key which will concatenate in string with several
// '&sort=' props, which looks is the only way BE supports multi criteria sorting
export const sortToString = (sort: Array<{ property: string, direction: string }>): string => {
  const result =
    sort &&
    sort
      .map((criteria: { direction: string, property: string, id?: string }, index: number) => {
        const result = `${toSnakeCase(
          criteria.property || criteria.id,
        )},${criteria.direction.toLowerCase()}`;
        return index > 0 ? `&sort=${result}` : result;
      })
      .toString();
  return result;
};

export const toTableSortV2 = (sort: Array<{ property: string, direction: string }>) => {
  return sort.map(i => ({
    columnKey: camelcase(i.property),
    direction: i.direction.toUpperCase(),
  }));
};
